// assets
import { IconSettings } from '@tabler/icons';
import { isMerchant } from 'helper/Admin';
import { getUrlCourtCode } from 'helper/Court';

// constant
const icons = {
    IconSettings
};

const courtCode = getUrlCourtCode();
const merchantBaseUrl = `/${courtCode}/merchants`;
const courtBaseUrl = `/${courtCode}/courts`;

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const children = [
    {
        id: 'merchants',
        title: isMerchant() ? 'Court' : 'Merchants',
        type: 'item',
        url: merchantBaseUrl,
        icon: icons.IconSettings,
        children: [
            {
                id: 'merchantadd',
                title: 'Add',
                type: 'item',
                url: `${merchantBaseUrl}/add`,
                breadcrumbs: true
            },
            {
                id: 'merchantedit',
                title: 'Edit',
                type: 'item',
                url: `${merchantBaseUrl}/edit`,
                breadcrumbs: true
            },
            {
                id: 'adminadd',
                title: 'Admin',
                type: 'item',
                url: `${merchantBaseUrl}/admins/add`,
                breadcrumbs: true
            },
            {
                id: 'adminedit',
                title: 'Admin',
                type: 'item',
                url: `${merchantBaseUrl}/admins/edit`,
                breadcrumbs: true
            }
        ]
    }
];

if (!isMerchant()) {
    children.push({
        id: 'courts',
        title: 'Court',
        type: 'item',
        url: courtBaseUrl,
        icon: icons.IconSettings,
        children: [
            {
                id: 'courtadd',
                title: 'Add',
                type: 'item',
                url: `${courtBaseUrl}/add`,
                breadcrumbs: true
            },
            {
                id: 'courtedit',
                title: 'Edit',
                type: 'item',
                url: `${courtBaseUrl}/edit`,
                breadcrumbs: true
            }
        ]
    });
}

const settings = {
    id: 'settings',
    title: 'Setting',
    caption: '',
    type: 'group',
    children
};

export default settings;